var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleCheckBoxBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#303141"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7803 6.21967C15.0732 6.51256 15.0732 6.98744 14.7803 7.28033L8.78033 13.2803C8.48744 13.5732 8.01256 13.5732 7.71967 13.2803L5.21967 10.7803C4.92678 10.4874 4.92678 10.0126 5.21967 9.71967C5.51256 9.42678 5.98744 9.42678 6.28033 9.71967L8.25 11.6893L13.7197 6.21967C14.0126 5.92678 14.4874 5.92678 14.7803 6.21967Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckBoxBlack);
export default __webpack_public_path__ + "static/media/circleCheckBoxBlack.b784d73701810bf5e8a5b4b86b5b8a31.svg";
export { ForwardRef as ReactComponent };